export const sortByTitle = function <T extends { title: string }> (array: Array<T>) {
  return array.sort((a, b) => (a.title > b.title ? 1 : -1))
}
